import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from '@/store';
import { initSentry } from '@/config/sentry';
import { installAntdApiNotifier } from '@/api/antdApiNotifier';
import { AppErrorBoundary } from '@/components/common/AppErrorBoundary';
// WEB-2054: кабинету куски рендерера блоков кладём сразу — превью
// конструктора обязано рисоваться тем же кадром, что и до разреза. Публичный
// вход (public-main.tsx) этого не делает: там куски едут по составу воронки.
import { registerPublicBlockChunksEagerly } from '@/player/registerPublicBlockChunksEagerly';
// WEB-3447: и единый ленивый кусок плеера (заход 3: одна дверь вместо трёх) —
// вычисляемые значения ({{bmi}} и др.), рамка экрана Slimkit, градиенты бренда
// с переменными пака и ленивые темы: превью конструктора рисует их тем же
// кадром, галерея тем находит «Blue Gradient»; покупателю — ленивым куском.
import { PLAYER_KIT } from '@/player/playerKit';
import { playerKitDoor } from '@/player/playerKitDoor';
import { registerPublicQuizStringPacksEagerly } from '@/utils/registerPublicQuizStringPacksEagerly';
// WEB-2384 п.6 (23.09.2026, временно): названия юридических документов на всех
// языках генерации — кабинету, чтобы редактор и предпросмотр узнавали их на
// любом языке воронки. Публичный вход берёт только английский и русский, пока
// владелец не решит вопрос №5 о весе первого экрана.
import { registerAllLegalDocLanguages } from '@/utils/legalDocNames';
// WEB-2534: кабинет держит весь каталог стиль-паков синхронно (галерея, редактор, предпросмотр).
import { registerAllStylePacks } from '@/themes/stylePackCatalog';
import App from './App';
import { APP_HOST, PUBLIC_APEX } from '@/config/public-host';
import { apexRootRedirectUrl } from '@/utils/cabinetHost';
import '@/styles/global.css';
// WEB-3737: токены и шрифты кабинета нового вида (под корнем `.ds`) — только
// кабинету; публичный вход (public-main.tsx) их не подключает.
import '@/styles/cabinet-tokens.css';

// WEB-2330: корень апекса зарезервирован под лендинг, кабинет — на APP_HOST.
// Если этот вход всё же раздали на сам корень (старая закладка, DNS ещё не
// переставлен) — уводим на кабинет с тем же путём и ничего не монтируем.
// На стенде APP_HOST равен апексу, и переадресации нет.
const apexRedirect = apexRootRedirectUrl(window.location, PUBLIC_APEX, APP_HOST);
if (apexRedirect) {
  window.location.replace(apexRedirect);
}

// WEB-469 (BC-1): must run before the first render so a crash during the
// initial mount is still captured. No-op when VITE_SENTRY_DSN is unset.
initSentry();

// WEB-1988: HTTP-клиент больше не импортирует Ant Design сам (иначе он тянул
// бы его в бандл покупателя воронки — второй вход сборки public.html).
// Тосты кабинета «сессия истекла» / «подтвердите почту» показывает вот этот
// подключённый показчик; он ставится ДО первого рендера, чтобы самый ранний
// отказ сервера не потерялся.
installAntdApiNotifier();

registerPublicBlockChunksEagerly();
playerKitDoor.register(PLAYER_KIT);
// WEB-2057: и надписи воронки на всех языках — превью конструктора меняет язык
// на лету и ждать файл не может.
registerPublicQuizStringPacksEagerly();
registerAllStylePacks();
registerAllLegalDocLanguages();

if (!apexRedirect) {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <AppErrorBoundary>
        <Provider store={store}>
          <App />
        </Provider>
      </AppErrorBoundary>
    </React.StrictMode>
  );
}
